import "./SingleProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import Product from "./sections/Product"
import Trustbadges from "./sections/Trustbadges"
import Footer from "@/reusable_sections/Footer"
import CustomerReviews from "./sections/CustomerReviews"
import RelatedProducts from "./sections/RelatedProducts"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Header />
      <Product />
      <RelatedProducts />
      <Trustbadges />
      <CustomerReviews />
      <Footer />
    </div>
  )
}